import { useMultiSelectorToQueryParam } from '../shared/useMultiSelectorToQueryParam'

import type { CheckBoxNode } from '~/core/ts/entity/CheckBoxNode'

export function useMultiHotelStarsFilter(options: globalThis.Ref<Array<CheckBoxNode>>) {
  const multiHotelStarsOptions = options

  const {
    optionsSelectedIDs,
    optionsSelected,
    onMultiPromoInput,
  } = useMultiSelectorToQueryParam( 'hotel-stars', multiHotelStarsOptions )

  const hotelStarsSelected = computed(() => {
    return optionsSelectedIDs.value.map(Number)
  })

  const hotelStarsSelectedNames = computed(() => {
    return optionsSelected.value.map((node) => node.label)
  })

  function onHotelStarsNodeClick(){
    onMultiPromoInput(multiHotelStarsOptions.value)
  }

  return {
    hotelStarsSelected,
    hotelStarsSelectedNames,
    onHotelStarsNodeClick,
  }
}
